/**
 * Build a per-checkout invoice number that's unique enough for client-side
 * use. Format: "INV" + last 8 digits of the millisecond timestamp + a 3-digit
 * random suffix. Authorize.Net dedupes invoice numbers within a window, so
 * the random suffix protects against same-millisecond resubmits.
 */
export function generateInvoiceNumber(): string {
  const timestamp = Date.now().toString().slice(-8);
  const random = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, "0");
  return `INV${timestamp}${random}`;
}
